<template>
	<div class="label-input">
		<label :for="id_">{{ label }}</label>
		<textarea
			:id="id_"
			:name="name"
			v-bind="attrs"
			v-model="value_"
			:disabled="disabled"
		></textarea>
	</div>
</template>

<script>
import { createNameFromVModelExpr } from '../../index';
export default {
	name: 'MTextArea',
	data() {
		return {
			name_: this.name,
			value_: this.value,
			id_: this.id
		}
	},
	props: {
		name: {
			type: String,
			required: false
		},
		label: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'text'
		},
		attrs: {
			type: Object,
			default() {
				return {}
			}
		},
		id: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		value_(new_) {
			this.$emit('input', new_);
		}
	},
	created() {
		const name = createNameFromVModelExpr(this);

		if (name && !this.id_) this.id_ = name;

		if (name && !this.name_) this._name = name;
	}
}
</script>

<style scoped></style>
